import { SlideInRight } from 'react-native-reanimated';

import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { ProductWizardStep } from 'state/product-wizard-v2/types';
import { primitive } from 'styles/constants/primitives';

export const getBackgroundColorByStep = (currentStep: ProductWizardStep) => {
  switch (currentStep) {
    case ProductWizardStep.ProductEditOrder:
    case ProductWizardStep.ProductCustomization:
    case ProductWizardStep.ProductReview:
      return primitive.$white;
    default:
      return Styles.color.white;
  }
};

export const getEnteringAnimationByProductWizardState = (currentStep: ProductWizardStep) => {
  switch (currentStep) {
    case ProductWizardStep.ProductCustomization:
      return SlideInRight;
    default:
      return;
  }
};

export const logCTAEvent = (name: string) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE_ACTION_CTA,
      name,
    },
  });
};
